// extracted by mini-css-extract-plugin
module.exports = {"openModalBtn":"ChangeClinic_openModalBtn__a8K4q","footer":"ChangeClinic_footer__sPFuh"};